import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ custom, palette }: Theme) => ({
  expand: {
    textDecoration: 'underline',
    '&:hover': {
      color: palette.primary.main,
    },
  },
  label: {
    display: 'block',
    width: '100%',
    fontSize: 12,
    color: custom.grey[3],
    lineHeight: 1.5,
    '& a': {
      color: 'inherit',
    },
    '& a:hover': {
      color: palette.primary.main,
    },
  },
  selectionRequired: {
    color: custom.status.danger.contrastText,
  },
  switchControlLabel: {
    alignItems: 'flex-start',
    marginBottom: 13,
    marginRight: 0,
  },
  switchRoot: {
    width: 50,
    height: 28,
    padding: 0,
    margin: '-3px 20px 0 10px',
  },
  switchBase: {
    padding: 4,
    '&.Mui-checked': {
      transform: 'translateX(22px)',
      color: 'white',
      '& + .MuiSwitch-track': {
        backgroundColor: palette.primary.main,
        opacity: 1,
      },
    },
  },
  switchThumb: {
    width: 20,
    height: 20,
  },
  switchTrack: {
    borderRadius: 28 / 2,
    backgroundColor: custom.grey[14],
    opacity: 1,
  },
}));
